export default "__VITE_ASSET__DuYeXsRs__"